<script>
import { columns } from './help'
import OperationForm
  from "./components/OperationForm.vue";
import {
  exportVerificationAndSign,
  insertVerificationAndSign, removeVerificationAndSign, removeVerificationAndSigns,
  selectVerificationAndSignList,
  updateVerificationAndSign
} from "@/api/enterpriseServiceActivitiesManagement";
import moment from "moment";
export default {
  name: 'VerificationAndSignManagement',
  components: {OperationForm: OperationForm},
  computed: {
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
        },
        getCheckboxProps: record => ({
          props: {
            disabled: record.status === '已失效'
          },
        }),
      };
    },
  },
  data() {
    return {
      columns,
      dataInfo: [],
      selectedRowKeys: [],
      searchForm: {
        //  用户ID
        userId: '',
        //  手机号
        phoneNumber: '',
        // 姓名
        userName: '',
      },
      //分页数据
      pagination: {
        showSizeChanger: true,
        current: 1,
        pageSize: 10,
        total: 0,
        showQuickJumper: true,
        showTotal: (total) => {
          return `共 ${total} 条`;
        },
      },
      // 操作类型
      operationType: 'add',
      // 弹窗
      visibleModal: false,
      // 弹窗确认loading
      confirmLoading: false,
      // 当前操作项
      operationData: {},
    }
  },
  async created() {
    // 获取列表
    await this.getList();
  },
  methods: {
    /**
     * @Description：列表
     * @Author cxd
     * @Date 2026/1/4 16:29
     */
    async getList() {
      const params = this.getParams()
      const res = await selectVerificationAndSignList(params);
      const { code, data, msg } = res;
      if (code === '200') {
        this.dataInfo = data.items
        this.pagination.total = data.total;
      } else {
        this.$message.error(msg)
      }
    },
    /**
     * @Description：整理检索参数
     * @Author cxd
     * @Date 2026/1/12 14:12
     */
    getParams () {
      return {
        ...this.searchForm,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ids: this.selectedRowKeys
      };
    },
    /**
     * @Description：检索
     * @Author cxd
     * @Date 2026/1/4 16:20
     */
    search() {
      this.pagination.current=1;
      this.pagination.pageSize=10;
      this.getList()
    },
    /**
     * @Description：重置
     * @Author cxd
     * @Date 2026/1/4 16:20
     */
    resetSearchForm() {
      this.searchForm = this.$options.data().searchForm;
      this.getList()
    },
    /**
     * @Description：新建
     * @Author cxd
     * @Date 2026/1/4 16:20
     */
    addBlacklist() {
      this.operationType = 'add';
      this.operationData = {};
      this.visibleModal = true;
    },
    /**
     * @Description：移除
     * @Author cxd
     * @Date 2026/1/4 16:20
     */
    removeItems() {
      this.removeVerificationAndSign(this.selectedRowKeys,true);
    },
    /**
     * @Description：分页操作
     * @Author cxd
     * @Date 2026/1/4 16:28
     */
    //分页操作
    pageChange(option) {
      this.pagination.current = option.current;
      this.pagination.pageSize = option.pageSize;
      this.getList();
    },
    /**
     * @Description：弹窗确认事件
     * @Author cxd
     * @Date 2026/1/4 16:50
     */
    handleOk() {
      this.$refs.operationForm.onSubmit()
    },
    /**
     * @Description：弹窗取消操作
     * @Author cxd
     * @Date 2026/1/4 16:51
     */
    handleCancel() {
      this.visibleModal = false;
    },
    /**
     * @Description：添加
     * @Author cxd
     * @Date 2026/1/12 15:38
     */
    async addVerificationAndSign(params) {
      try {
        this.confirmLoading = true;
        const res = this.operationType==='edit'? await updateVerificationAndSign(params) : await insertVerificationAndSign(params)
        if (res.code === '200') {
          this.$message.success(res.msg);
          await this.getList();
          this.visibleModal = false;
        } else {
          this.$message.error(res.msg)
        }
      } catch (e) {
        this.$message.error(e.msg)
      } finally {
        this.confirmLoading = false
      }
    },
    /**
     * @Description：移除
     * @Author cxd
     * @Date 2026/1/12 15:43
     */
    async removeVerificationAndSign(row,type) {
      const that = this
      this.$confirm({
        title: '移除后用户不可操作核销签到，是否确认移除？',
        okText: '确认',
        cancelText: '取消',
        onOk() {
          if (type) {
            that.removeVerificationAndSignByIds(row)
          } else {
            that.removeVerificationAndSignById(row)
          }
        },
        onCancel() {},
      })
    },
    /**
     * @Description: 单个移除
     * @Author: cxd
     * @Date: 2026/3/9 16:35
     */
    removeVerificationAndSignById(row) {
      removeVerificationAndSign(row.id).then(res => {
        if (res.code === '200') {
          this.$message.success('操作成功');
          this.selectedRowKeys = []
          this.getList();
        } else  {
          this.$message.error('操作失败')
        }
      })
    },

    /**
     * @Description: 批量移除
     * @Author: cxd
     * @Date: 2026/3/9 16:41
     */
    removeVerificationAndSignByIds(data) {
      removeVerificationAndSigns(data).then(res => {
        if (res.code === '200') {
          this.$message.success('操作成功');
          this.selectedRowKeys = [];
          this.getList();
        } else  {
          this.$message.error('操作失败')
        }
      })
    },

    /**
     * @Description：导出
     * @Author cxd
     * @Date 2026/1/12 15:50
     */
    async exportData() {
      const that = this
      const params = this.getParams()
      try {
        const res = await exportVerificationAndSign(params)
        const blob = new Blob([res.data]);
        const objectUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = objectUrl;
        a.setAttribute("download",  `核销签到人-${moment().format('YYYYMMDDHHmmss')}.xlsx`);
        a.click();
        that.selectedRowKeys = []
        that.visibleSignAgreement = false
      } catch(err) {
        that.$message.error('导出失败')
      }
    },
    /**
     * @Description：表格多选中事件
     * @Author cxd
     * @Date 2026/1/12 16:52
     */
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    /**
     * @Description：编辑
     * @Author cxd
     * @Date 2026/1/4 16:20
     */
    edit(row) {
      this.operationType = 'edit';
      this.operationData = row
      this.visibleModal = true
      // 查询详情
      // getVerificationAndSignById(row.id).then(res => {
      //     if (res.code === 200) {
      //       this.operationData = res.data;
      //       this.visibleModal = true;
      //     }
      // })
    },
  }
}
</script>

<template>
  <div class="black-list-main">
    <ds-header title="核销签到"></ds-header>
    <a-form layout="inline">
      <a-form-item label="用户ID：">
        <a-input v-model.trim="searchForm.userId" placeholder="请输入用户ID" class="inputClass" />
      </a-form-item>
      <a-form-item label="手机号：">
        <a-input v-model.trim="searchForm.phoneNumber" placeholder="请输入手机号" class="inputClass" />
      </a-form-item>
      <a-form-item label="姓名：">
        <a-input v-model.trim="searchForm.userName" placeholder="请输入姓名" class="inputClass" />
      </a-form-item>
      <span>
        <a-button type="primary" @click="search" style="margin-top: 3px"> <a-icon type="search" />查询 </a-button>
        <a-button style="margin-left: 15px" @click="resetSearchForm">重置</a-button>
      </span>
    </a-form>
    <div style="padding-top: 15px">
      <a-button type="primary" @click="addBlacklist()"> <a-icon type="plus" />添加</a-button>
      <a-button style="margin-left: 15px" type="primary" @click="exportData()"> <a-icon type="export" />导出</a-button>
      <a-button style="margin-left: 15px" :disabled="selectedRowKeys && selectedRowKeys.length === 0" type="primary" @click="removeItems()"> <a-icon type="delete" />移除</a-button>
    </div>
    <div style="margin-top: 15px">
      <a-table
          :rowKey="(record, index) => record.id"
          :columns="columns"
          :data-source="dataInfo"
          :pagination="pagination.total ? pagination : false"
          @change="pageChange"
          bordered
          :scroll="{ x: 1500 }"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      >
        <span slot="reason" slot-scope="text, record">
          <a-tooltip>
            <template slot="title">{{ record.reason }}</template>
            <span class="field">{{ record.reason }}</span>
          </a-tooltip>
        </span>
        <span slot="action" slot-scope="text, record" class="action">
<!--          <a-button class="btnClass" type="link" @click="edit(record)"> 编辑 </a-button>-->
          <a-button v-show="record.status !== '已失效'" class="btnClass" type="link" @click="removeVerificationAndSign(record, false)" > 移除 </a-button>
        </span>
      </a-table>
    </div>
    <a-modal
        :title="operationType === 'add' ? '添加' : '编辑'"
        :visible="visibleModal"
        :confirm-loading="confirmLoading"
        destroyOnClose
        width="600px"
        @ok="handleOk"
        @cancel="handleCancel"
        :maskClosable="false"
    >
      <operation-form
          ref="operationForm"
          :operationData="operationData"
          :operationType="operationType"
          @addVerificationAndSign="addVerificationAndSign"
      />
    </a-modal>
  </div>
</template>

<style scoped lang="scss">
.field {
  font-size: 12px;
  display: inline-block;
  height: auto;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  font-weight: 500;
}
</style>